import store from "@/store";

const routes = [{
    path: "/operations/checkerForms/:id",
    name: "warehousecf",
    component: () => import('@/views/main/modules/Operations/CF/CheckerFormGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Checker Forms',
    }
}]

export default routes;
